"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Text = require("../Text/Text");
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _excluded = ["classes", "className", "component", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ElementType } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.monospace), {}, {
      display: 'inline',
      paddingLeft: '.5rem',
      paddingRight: '.5rem',
      border: "1px solid ".concat(theme.colors.lightGrey),
      borderRadius: theme.variables.borderRadiusSmall
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Component to be used as code renderer
   *-/
  component: ElementType
};*/
function MarkdownCodeSpan(props /*: Props*/) {
  var classes = props.classes,
    classNameProp = props.className,
    Component = props.component,
    theme = props.theme,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var className = (0, _classnames.default)(classes.root, classNameProp);
  return /*#__PURE__*/_react.default.createElement(Component, _objectSpread(_objectSpread({}, other), {}, {
    className: className,
    component: _Text.Monospace
  }));
}
MarkdownCodeSpan.displayName = 'MarkdownCodeSpan';
MarkdownCodeSpan.defaultProps = {
  component: _Text.Monospace
};
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownCodeSpan);
//# sourceMappingURL=CodeSpan.js.map